// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ced09912","239":"17f79435","455":"2fd03dcf"}[chunkId] + ".chunk.js";
};